import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BusinessForwardSearchItem } from 'components/business';
import { Categories } from 'base/api';
import ReactPaginate from 'react-paginate';
import { ShowIf, NoContent } from 'components/utils';
import _ from 'lodash';

class BusinessForwardQuotesSearchList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      businesses: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      selected: 0,
      selectedCategoryId: '',
      isSearched: false,
      categories: [],
      isLoading: false
    }

    this.handleChoose = this.handleChoose.bind(this);
    this.setDefaultBusiness = this.setDefaultBusiness.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.postLoadBusinesses = this.postLoadBusinesses.bind(this);
    this.loadBusinessesFromServer = this.loadBusinessesFromServer.bind(this);
    this.postLoadcategories = this.postLoadcategories.bind(this);
    this.loadCategoriesFromServer = this.loadCategoriesFromServer.bind(this);
    this.loadCountBusinessFromServer = this.loadCountBusinessFromServer.bind(this);
  }

  static propTypes = {
    onChoose: PropTypes.func.isRequired,
    limit: PropTypes.number
  }

  static defaultProps = {
    limit: 10
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'UPDATE_BUSINESSES_LIST',
      businesses: []
    });
    this.loadCategoriesFromServer();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listBusinesses != this.state.listBusinesses) {
      this.setState({isLoading: true}, () => {
        this.setState({
          businesses: nextProps.listBusinesses
        }, () => {
          this.setState({isLoading: false});
        });
      })
    }
    if (nextProps.listCategories != this.state.listCategories) {
      this.setState({
        categories: nextProps.listCategories
      });
    }
  }

  setDefaultBusiness() {
    this.setState({
      businesses: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      selected: 0,
      selectedCategoryId: '',
      isSearched: false
    });
  }

  handleSelect(e) {
    let value = e.target.value;

    if (!value) {
      this.setDefaultBusiness();
      return this.props.dispatch({
        type: 'CATEGORIES_TO_TREE',
        businesses: []
      });
    }

    this.setState({
      isLoading: true
    }, () => {
      this.setState({
        selectedCategoryId: value,
        isSearched: true
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.loadCountBusinessFromServer(value);
        this.loadBusinessesFromServer();
      }, 1000);
    });
  }

  loadCountBusinessFromServer(id) {
    Categories.actions.countBusinessesByCategoryId.request({id}).then(res => {
      if (res && res.data && res.data.count) {
        let total = res.data.count;
        let pageCount = Math.ceil(total / this.props.limit);
        this.setState({pageCount, total});
      }
    });
  }

  loadBusinessesFromServer() {
    Categories.actions.getBusinesses.request({
      id: this.state.selectedCategoryId,
      filter: {
        limit: this.props.limit,
        skip: this.state.offset
      }
    }).then(res => {
      this.postLoadBusinesses(res.data);
    });
  }

  postLoadBusinesses =(data) => {
    if (!data) {
      return;
    }

    this.props.dispatch({
      type: 'UPDATE_BUSINESSES_LIST',
      businesses: data
    });
  }

  loadCategoriesFromServer() {
    Categories.actions.list.request().then(res => {
      this.postLoadcategories(res.data);
    });
  }

  postLoadcategories =(data) => {
    if (!data) {
      return;
    }

    this.props.dispatch({
      type: 'UPDATE_CONSULTING_CATEGORIES_LIST',
      categories: data
    });
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({offset, selected}, () => {
      this.loadBusinessesFromServer();
    });
  };

  handleChoose = (id) => {
    const business = _.find(this.state.businesses, item => item.id === id);
    if (!id || !business) {
      return;
    }

    let businessResult = {
      ...{},
      id: id,
      logo: business.logo,
      name: business.name,
      phone: business.phone,
      email: business.email,
    };

    this.props.onChoose && this.props.onChoose(businessResult);
  }

  render() {
    const { isLoading, isSearched, businesses, selectedCategoryId, total, pageCount, selected, categories } = this.state;
    return (
      <div className="content">
        <div className="form-group">
          <label>Lọc doanh nghiệp theo lĩnh vực</label>
          <select className="form-control" name="catogory" onChange={this.handleSelect.bind(this)} value={selectedCategoryId}>
            <option value="">Chọn lĩnh vực</option>
            {categories && categories.map((category, i) => (
              <option value={category.id}>{category.name}</option>
            ))}
          </select>
        </div>
        <ShowIf condition={isLoading || (businesses && businesses.length === 0)}>
          <NoContent
            content={
              isLoading ? 'Đang tải dữ liệu...' : (
                isSearched ? 'Không có kết quả nào' : 'Hãy chọn lĩnh vực'
              )
            }
            height={300}
          />
        </ShowIf>
        <ShowIf condition={!isLoading && businesses && businesses.length > 0}>
          <table className="table table-striped businesses-forward-table">
            <thead className="thead">
              <tr className="tr-head">
                <th scope="col" className="col-lg-1">
                  #
                </th>
                <th scope="col" className="col-lg-8">
                  Doanh nghiệp
                </th>
                <th scope="col" className="col-lg-3 text-center">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="tbody">
              {businesses.map((business, i) => (
                <BusinessForwardSearchItem
                  key={i}
                  data={business}
                  index={(i + 1 + ((selected) * this.props.limit))}
                  onChoose={this.handleChoose}
                  isCanNotChoose={_.indexOf(this.props.disabledIdList, business.id) !== -1}/>
              ))}
            </tbody>
          </table>
        </ShowIf>
        <ShowIf condition={businesses && businesses.length > 0 && total > this.props.limit}>
          <ReactPaginate previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={pageCount - 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  listBusinesses: state.listBusinesses,
  listCategories: state.categoriesAsTree
});

export default connect(mapStateToProps)(BusinessForwardQuotesSearchList);


// WEBPACK FOOTER //
// ./components/business/BusinessForwardQuotesSearchList.jsx